
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Results </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.webp"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm result section-banner-bg-1">
    <div class="container">
        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys">
                        <h4>COMPETITION RESULTS</h4>
                    </div>
                </div>

            </div>
            <div class="row  row-cols-1 row-cols-lg-4 ">
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/gondia-dist-badminton-tournament-final-results-sheet1.pdf" target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Gondia District badminton Championship 2024</h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1CXEIeC4txTtoy9mKGA6SjAe_xBgyBwrO/view" target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>I Too Love My Nation </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1WHFk5denRdj_m8biPhhTJe4ir1f9y3V4/view" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>I Too Have A Talent </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1_vcW3DjZLX3fTHAz1wC5HrY5vTzdF8JM/view?usp=sharing" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Fide Chess Competition 2018 </h4>
                            </div>
                        </div>
                    </a>
                </div>


            </div>
        </div>

        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys">
                        <h4>EMPLOYEE SPORTS MEET RESULTS</h4>
                    </div>
                </div>

            </div>
            <div class="row  row-cols-1 row-cols-lg-4">
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/neev-winners26.pdf" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>22<sup>th</sup> Sports Meet 2026 </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/neev-2025-winner-sheet.pdf" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Employee Sports Meet 2025 </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1BFVGE5UhoezaKY_nxhB0npQ3yKjC_ZRg/view?usp=sharing" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Employee Sports Meet 2023 </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1v2qolKcbrGGntORVJJX-_5REoGC8kZke/view" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Employee Sports Meet 2022 </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1Yn4b1jq6LAolp7g2IoFODQdozoi2Zktn/view" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Employee Sports Meet 2021 </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1t3-H9ZhotgCAdzY-Gi9f2izyUHSTSJVz/view" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Employee Sports Meet 2020 </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1c1KBW39sTvbWvS8A7TUFIY-eyCUNVhRs/view?usp=sharing" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Employee Sports Meet 2019 </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1fZgl5Vb4gCvEJ1nMe8YrPIf9uFx7Zzjc/view?usp=sharing" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Employee Sports Meet 2018 </h4>
                            </div>
                        </div>
                    </a>
                </div>
            </div>

        </div>


    </div>
</section>
